<p-dialog
  position="middle"
  [id]="id"
  class="mu-modal mu-modal-big-content"
  [(visible)]="showModalState"
  (onHide)="_eventCloseDialogModal()"
>
  <div class="p-grid p-justify-center p-align-center">
    <section id="login" class="login">
      <div class="p-grid" id="mu-auth-login">
        <div class="p-col-12 mu-without-padding">
          <h6 class="mu-layout-auth-sub-title" [innerHTML]="'page.login.titleModalService' | translate"></h6>
        </div>
        <div class="p-col-12 mu-without-padding">
          <app-login-shared [actionList]="loginActions"></app-login-shared>
          <div class="mu-modal-line"></div>
          <p>
            <span>{{ 'page.login.register.1' | translate }}</span>
            <a [routerLink]="['/crear-cuenta']">{{ 'page.login.register.2' | translate }}</a>
          </p>
        </div>
      </div>
    </section>
  </div>
</p-dialog>
